(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Rubro', Rubro);

    Rubro.$inject = ['$resource'];

    function Rubro ($resource) {
        var resourceUrl =  'api/rubros/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
